module.exports = __webpack_public_path__ + "ccp-dist/img/footer-paymentsense-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-paymentsense-logo.svg
// module id = VRgu
// module chunks = 1